<template>
  <div class="user-center__content">
    <div class="user-center__avatar">
      <img
        v-if="userInfo.headPicPath"
        :src="userInfo.headPicPath"
        class="avatar"
      />
      <svg-icon v-else class-name="avatar" icon-class="avatar" />
    </div>
    <div class="user-center__account">
      {{ userInfo.userNm }}
    </div>
    <div class="user-center__name">
      <span>
        {{
          [userInfo.userRealNm, userInfo.compNm]
            .filter((val) => val)
            .join(" / ")
        }}
      </span>
      <a-tag color="green">{{ userInfo.userStNm }}</a-tag>
    </div>
    <div class="user-center__expireTime">
      <span>
        {{
          [
            userInfo.actvFrYmd &&
              moment(userInfo.actvFrYmd, "YYYYMMDD").format("YYYY/MM/DD"),
            userInfo.actvToYmd &&
              moment(userInfo.actvToYmd, "YYYYMMDD").format("YYYY/MM/DD"),
          ]
            .filter((item) => item)
            .join("~")
        }}
        <br />
        <br />
        {{ userInfo.userDivNm }}
      </span>
      <span>
        {{ $t("expiration_date_remaining") }}
        {{ moment(userInfo.actvToYmd).fromNow(true) }}
      </span>
    </div>
    <div class="user-center__title">
      {{ $t("loginInfo") }}
    </div>
    <div class="user-center__login-tips">
      {{ $t("bindingDescription") }}
    </div>
    <div class="user-center__login">
      <div class="user-center__login-item">
        <label>{{ $t("mobileNo") }}</label>
        <a>
          <div v-if="!userInfo.phonNo">{{ $t("bind") }}</div>
          <div v-else>
            <span class="bind-text">{{ userInfo.phonNo }}</span>
            <svg-icon v-if="false" class-name="switch" icon-class="switch" />
          </div>
        </a>
      </div>
      <div class="user-center__login-item">
        <label>{{ $t("email") }}</label>
        <a>
          <div v-if="!userInfo.emalAd">{{ $t("bind") }}</div>
          <div v-else>
            <span class="bind-text">{{ userInfo.emalAd }}</span>
            <svg-icon v-if="false" class-name="switch" icon-class="switch" />
          </div>
        </a>
      </div>
      <div class="user-center__login-item">
        <label>{{ $t("wechat") }}</label>
        <a @click="bind('wechat')">
          <iw-popover v-model="visible" placement="bottom" show-arrow>
            <template slot="reference">
              <div v-if="!userInfo.wxNickNm">
                <div>{{ $t("bind") }}</div>
              </div>
              <div v-else>
                <span class="bind-text">
                  <img
                    v-if="userInfo.headPicPath"
                    :src="userInfo.headPicPath"
                    class="avatar avatar-mini"
                  />
                  {{ userInfo.wxNickNm }}
                </span>
                <svg-icon class-name="switch" icon-class="switch" />
              </div>
            </template>
            <div class="user-center__qrcode">
              <img
                class="user-center__img"
                :src="bindQrcode && bindQrcode.qrcode"
              />
              <div class="user-center__text">{{ $t("wechatDescription") }}</div>
              <svg-icon
                v-if="qrCodeStatus === qrcodeLoginStatus['SUCCESS']"
                class="icon-success"
                icon-class="login-sucess"
              />
            </div>
          </iw-popover>
        </a>
      </div>
    </div>
    <div class="user-center__footer">
      <router-link to="/protocol?key=service" target="_blank"
        >《服务协议》</router-link
      >
      <router-link to="/protocol?key=usage" target="_blank"
        >《使用协议》</router-link
      >
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters, mapState } from "vuex";
import { getQRCodeStatus, doBindQrcode } from "@/api/weixin";
let qrCodeTimer = null;
const channels = {
  XIAOCHENGXU: 2,
  PC: 1,
};

export default {
  data() {
    return {
      visible: false,
      qrCodeStatus: "1",
      qrcodeLoginStatus: {
        PENDING: "0",
        SUCCESS: "3",
      },
      showMoreAccountStatus: false,
    };
  },
  computed: {
    ...mapState({
      token: (state) => state.user.token,
      userInfo: (state) => state.user.userInfo,
      bindQrcode: (state) => state.user.userInfo.bindQrcode,
    }),
    ...mapGetters(["language"]),
  },
  watch: {
    visible() {
      clearInterval(qrCodeTimer);
      if (this.visible) {
        qrCodeTimer = setInterval(async () => {
          if (this.qrCodeStatus !== this.qrcodeLoginStatus["SUCCESS"]) {
            const { qrcodeId } = this.bindQrcode;
            const response = await getQRCodeStatus({
              qrcodeId: qrcodeId,
            });
            this.qrCodeStatus = response.data.data;
          } else {
            // 绑定成功
            console.log("绑定成功");
            clearInterval(qrCodeTimer);
            this.qrCodeStatus = "1";
            // 关闭二维码弹出层
            this.visible = false;
            // 获取用户信息
            this.$store.dispatch("user/getUserInfo");
          }
        }, 2000);
      }
    },
  },
  mounted() {
    this.$store.dispatch("user/getUserInfo");
    clearInterval(qrCodeTimer);
  },
  methods: {
    moment() {
      return moment(...arguments).locale(this.language);
    },
    bind(panelType) {
      if (panelType === "wechat") {
        // const { qrcode } = this.bindQrcode || {};
        // if (!qrcode) {
        this.$store.dispatch("user/getBindQRCode");
        // }
        return;
      }
      this.$emit("changeShowPanel", { showPanel: 2, panelType });
    },
    showMoreAccount() {
      this.showMoreAccountStatus = !this.showMoreAccountStatus;
    },
    switchAccount(item) {
      this.$store
        .dispatch("user/switchAccount", {
          channel: channels["PC"],
          userId: item.userId,
        })
        .then(() => {
          this.$message({
            type: "success",
            message: "切换账号成功",
            customClass: "message-success",
          });
          window.location.reload();
          // this.$store.dispatch("user/getUserInfo");
          // // 更新全局token
          // actions.setGlobalState({
          //   token: this.token,
          //   time: moment().format("yyyy.MM.DD HH:mm:ss")
          // });
        });
    },
    doBindQrcode(data) {
      doBindQrcode(data);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_handle.scss";

.user-center__content {
  padding: 0;
  height: 100%;

  .avatar {
    width: 72px;
    height: 72px;
    vertical-align: middle;
    border-radius: 50%;
    &.avatar-mini {
      width: 28px;
      height: 28px;
    }
  }

  .user-center__account {
    font-size: 20px;
    margin-top: 16px;
    line-height: 28px;
    font-weight: bold;
  }

  .user-center__name {
    font-size: 16px;
    margin-top: 8px;
    padding-bottom: 8px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #f2f3f5;
  }

  .user-center__expireTime {
    font-size: 14px;
    color: #bcc0cc;
    line-height: 14px;
    margin-top: 16px;
    display: flex;
    justify-content: space-between;
  }

  .user-center__moreAccount {
    margin-top: 27px;
    font-size: 14px;
    .user-center__account-item {
      padding: 20px;
      background: #f7f8fa;
      margin-bottom: 10px;
      &.is-expire {
        opacity: 0.5;
      }
      .user-center__account-title {
        font-size: 20px;
        a {
          font-size: 14px;
          float: right;
          cursor: default;
          @include color("primary");
          &.switch {
            cursor: pointer;
          }
        }
      }
      // .user-center__account-realName {
      // }
      .user-center__account-expireTime {
        color: #6e758a;
      }
    }
    > a {
      margin-top: 10px;
      display: inline-block;
      @include color("primary");
    }
  }

  .user-center__title {
    font-weight: bold;
    font-size: 20px;
    line-height: 20px;
    margin-top: 60px;
  }

  .user-center__login-tips {
    font-size: 12px;
    color: #6e758a;
    line-height: 12px;
    margin-top: 10px;
  }

  .user-center__login {
    margin-top: 30px;
  }

  .user-center__login-item {
    height: 56px;
    line-height: 24px;
    margin-top: 4px;
    padding: 16px 0px;
    border-bottom: 1px solid #f2f3f5;
    label {
      font-size: 14px;
      font-weight: bold;
    }
    a {
      float: right;
      @include color("primary");
      .bind-text {
        height: 28px;
        line-height: 28px;
        display: inline-block;
        vertical-align: middle;
        overflow: hidden;
        color: #6e758a;
        margin-right: 4px;
      }
    }
    .switch {
      width: 24px;
      height: 24px;
    }
  }

  .user-center__footer {
    position: absolute;
    bottom: 16px;
    text-align: center;
    width: calc(100% - 48px);
    font-size: 12px;
  }
}
</style>
